import { acConfig } from '@ac/library-utils/dist/declarations';

export const getNewUrlForCashieringModule = (): string => {
  return `${window.location.origin}${acConfig.newFrontendUrls.cashiering}/dashboard`;
};
